export default "__VITE_ASSET__Bt5CWPgd__"